import styled, { css } from "styled-components/native";
import { Button } from "react-native-paper";
import ITouchableButtonProps from "../../models/ITouchableButtonProps";
import ComponentTypeEnum from "../../models/ComponentTypeEnum";
import { macaroni_and_cheese, mid_blue, navy_blue, peacock_blue, royal_blue, dark, white_smoke, black } from "../../StyleHelpers";
import { useState } from "react";
import useGenericContentStore from "../../store/genericContent.store";

interface BtnProps {
	type?: ComponentTypeEnum;
	disabled: boolean;
	addMarginLeft?: boolean;
	addMarginRight?: boolean;
	isStreamProgress?: any;
	isHovered?: any;
	isNarrow?: boolean;
	isPreview?: boolean;
}

//Note: edit flex value to allow/disable occupying whole width of button in flex component
const StyledBtnPaper = styled(Button)<BtnProps>`
	flex-grow: 1;
	flex-shrink: 1;
	flex-basis: 100%;
	justify-content: center;

	${(props) =>
		props.isNarrow &&
		css`
			border-radius: ${props.isPreview ? "8px" : "0.75rem"};
		`}

	${(props) =>
		!props.isNarrow &&
		css`
			border-radius: 16px;
		`}

	${({ addMarginLeft, addMarginRight }) => css`
		margin-left: ${addMarginLeft ? 10 : 0}px;
		margin-right: ${addMarginRight ? 10 : 0}px;
	`}

	${(props) => {
		switch (props.type) {
			case ComponentTypeEnum.Primary:
				return css`
					background: ${props?.isHovered ? peacock_blue : mid_blue};
				`;
			case ComponentTypeEnum.Secondary:
				return css`
					background: ${props?.isHovered ? navy_blue : royal_blue};
				`;
			case ComponentTypeEnum.Tertiary:
				return css`
					background: ${macaroni_and_cheese};
				`;
			case ComponentTypeEnum.Dark:
				return css`
					background: ${dark};
				`;
			default: //use primary as default
				return css`
					background: ${mid_blue};
				`;
		}
	}}
	${(props) =>
		props.isStreamProgress &&
		css`
			background-image: linear-gradient(to left, ${mid_blue} 0 ${100 - props.isStreamProgress}%, ${peacock_blue} 0 ${props.isStreamProgress}%);
		`}
`;

const StyledText = styled.Text<any>`
	line-height: 1.75rem;
	display: flex;
	font-size: ${(props) => (props.isNarrow ? "1.3125rem" : "1.5625rem")};
	white-space: normal;
	color: ${(props) => (props.type === ComponentTypeEnum.Tertiary ? black : white_smoke)};

	${(props) =>
		!props.leftText &&
		css`
			justify-content: center;
			align-items: center;
		`}
`;

// Specs: https://callstack.github.io/react-native-paper/button.html
const TouchableButtonVinfast = (props: ITouchableButtonProps) => {
	const [isHovered, setIsHovered] = useState(false);
	const isNarrow = useGenericContentStore((state: any) => state.isNarrow);
	return (
		// @ts-ignore
		<StyledBtnPaper
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			isHovered={isHovered}
			id={props.nativeID}
			mode="contained-tonal"
			type={props.type}
			onPress={props.onPress}
			onLongPress={props.onLongPress}
			{...props}
			disabled={props.disabled}
			isStreamProgress={props.isStreamProgress}
			labelStyle={
				props.disabled
					? {
							width: "100%",
							color: "white",
							opacity: 0.5,
							marginLeft: props.removeMargin ? "0" : "",
							marginRight: props.removeMargin ? "0" : "",
						}
					: { width: "100%", marginLeft: props.removeMargin ? "0" : "", marginRight: props.removeMargin ? "0" : "" }
			}
			contentStyle={{ height: isNarrow ? "3.5rem" : "4.5rem", width: "100%" }}
			isNarrow={isNarrow}
		>
			{/* @ts-ignore */}
			<StyledText leftText={props.leftText} type={props.type} isNarrow={isNarrow}>
				{props.children}
			</StyledText>
		</StyledBtnPaper>
	);
};

export default TouchableButtonVinfast;
